import React from "react";
import { Form, Row, Col, Card, Badge, Button } from "react-bootstrap";

const WebhooksTab = ({
    form,
    setForm
}) => {

    const updateWebhook = (key, value) => {

        setForm(prev => ({
            ...prev,
            webhooks: {
                ...prev.webhooks,
                [key]: value
            }
        }));

    };

    const toggleEvent = (key) => {

        setForm(prev => ({
            ...prev,
            webhooks: {
                ...prev.webhooks,
                events: {
                    ...prev.webhooks?.events,
                    [key]: !prev.webhooks?.events?.[key]
                }
            }
        }));

    };

    const events = [
        {
            key: "message_received",
            label: "Mensagem recebida",
            description: "Dispara quando uma nova mensagem chega"
        },
        {
            key: "message_sent",
            label: "Mensagem enviada",
            description: "Dispara quando uma mensagem é enviada"
        },
        {
            key: "message_status",
            label: "Status da mensagem",
            description: "Entregue, lida, falha, etc"
        },
        {
            key: "qr_updated",
            label: "QR Code atualizado",
            description: "Quando o QRCode do WhatsApp muda"
        },
        {
            key: "connection_opened",
            label: "Conexão aberta",
            description: "Quando o dispositivo conecta"
        },
        {
            key: "connection_closed",
            label: "Conexão fechada",
            description: "Quando o dispositivo desconecta"
        },
        {
            key: "contact_updated",
            label: "Contato atualizado",
            description: "Atualização de dados do contato"
        },
        {
            key: "group_updated",
            label: "Grupo atualizado",
            description: "Mudanças em grupos (WhatsApp)"
        }
    ];

    return (

        <>

            {/* HEADER */}

            <Card className="mb-3 border-0 bg-light">

                <Card.Body>

                    <strong>

                        Webhooks

                    </strong>

                    <div className="text-muted small">

                        Configure eventos que serão enviados para seu backend Laravel ou APIs externas.

                    </div>

                </Card.Body>

            </Card>

            {/* URL BASE + TOKEN */}

            <Row className="mb-4">

                <Col md={8}>

                    <Form.Group>

                        <Form.Label>

                            URL do Webhook

                        </Form.Label>

                        <Form.Control
                            placeholder="https://seudominio.com/api/webhooks/provider"
                            value={form.webhooks?.url || ""}
                            onChange={(e) =>
                                updateWebhook("url", e.target.value)
                            }
                        />

                        <Form.Text className="text-muted">

                            Endpoint que receberá os eventos HTTP POST.

                        </Form.Text>

                    </Form.Group>

                </Col>

                <Col md={4}>

                    <Form.Group>

                        <Form.Label>

                            Token de validação

                        </Form.Label>

                        <Form.Control
                            type="password"
                            placeholder="Token secreto"
                            value={form.webhooks?.token || ""}
                            onChange={(e) =>
                                updateWebhook("token", e.target.value)
                            }
                        />

                        <Form.Text className="text-muted">

                            Usado para validar origem dos eventos.

                        </Form.Text>

                    </Form.Group>

                </Col>

            </Row>

            {/* EVENTOS */}

            <Card className="mb-2">

                <Card.Body>

                    <div className="d-flex justify-content-between align-items-center mb-3">

                        <strong>

                            Eventos disponíveis

                        </strong>

                        <Badge bg="secondary">

                            {Object.values(form.webhooks?.events || {}).filter(Boolean).length} ativos

                        </Badge>

                    </div>

                    <Row>

                        {

                            events.map(event => (

                                <Col md={6} className="mb-3" key={event.key}>

                                    <Card
                                        style={{
                                            cursor: "pointer",
                                            border: form.webhooks?.events?.[event.key]
                                                ? "2px solid #0d6efd"
                                                : "1px solid #dee2e6",
                                            background: form.webhooks?.events?.[event.key]
                                                ? "#f0f6ff"
                                                : "#fff",
                                            transition: "all .2s ease"
                                        }}
                                        onClick={() => toggleEvent(event.key)}
                                    >

                                        <Card.Body>

                                            <div className="d-flex justify-content-between">

                                                <div>

                                                    <strong>

                                                        {event.label}

                                                    </strong>

                                                    <div className="text-muted small">

                                                        {event.description}

                                                    </div>

                                                </div>

                                                <Form.Check
                                                    type="switch"
                                                    checked={!!form.webhooks?.events?.[event.key]}
                                                    onChange={() => toggleEvent(event.key)}
                                                />

                                            </div>

                                        </Card.Body>

                                    </Card>

                                </Col>

                            ))

                        }

                    </Row>

                </Card.Body>

            </Card>

            {/* SEGURANÇA AVANÇADA */}

            <Card className="border-0 bg-light">

                <Card.Body>

                    <div className="d-flex justify-content-between">

                        <strong>

                            Segurança

                        </strong>

                    </div>

                    <div className="mt-3">

                        <Form.Check
                            type="checkbox"
                            label="Validar assinatura HMAC (recomendado)"
                            checked={form.webhooks?.hmac || false}
                            onChange={(e) =>
                                updateWebhook("hmac", e.target.checked)
                            }
                        />

                        <Form.Check
                            type="checkbox"
                            label="Retry automático em falhas"
                            checked={form.webhooks?.retry || false}
                            onChange={(e) =>
                                updateWebhook("retry", e.target.checked)
                            }
                        />

                    </div>

                </Card.Body>

            </Card>

        </>

    );

};

export default WebhooksTab;